module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-3-de-DE-12061677f004be948181de1930d42737.png";